import { request } from "@src/utils/request";
import { reRenderFramerProfile } from "../farmerProfile/farmerProfile";
import "./recentBlog.css";

const URL_PREFIX = "/farmer";

export interface IBlog {
  slug: string;
  path: string;
  coverComputer: string;
  coverTablet: string;
  coverDescription: string;
  title: string;
  publishedDate: string;
}

export default function setupRecentBlog() {
  let containerEle = document.querySelector<HTMLElement>(
    ".container-recent-blog"
  );
  const listWrapEle = document.querySelector<HTMLElement>(
    "[data-element-id='recent-blog-list-wrap']"
  );
  const framerProfile = document.querySelector<HTMLElement>(
    ".container-farmer-profile"
  );
  if (!listWrapEle || !containerEle || !framerProfile) return;
  const farmerId = framerProfile.dataset.farmerUsername;
  const currentBlogId = containerEle.dataset.currentBlog;
  if (!currentBlogId || !farmerId) return;

  renderList();

  function fetchList() {
    return request(`${URL_PREFIX}-${farmerId}.json`)
      .then((res) => res?.json())
      .then((response) => {
        const list = response?.blogs;
        if (!Array.isArray(list)) return [];
        if (response?.farmer) {
          reRenderFramerProfile(response.farmer);
        }

        return list.filter((item) => item.slug !== currentBlogId).slice(0, 4);
      })
      .catch((error) => console.error(error.message));
  }

  function generateHTMLTemplate(list: IBlog[]) {
    return list.reduce(
      (acc, current) =>
        acc +
        `  <li class="container-recent-blog-item">
            <a href="${current.path}">
              <div
                class="container-recent-blog-item-cover grid place-content-center rounded-lg lg:rounded-3xl overflow-hidden"
              >
                <picture>
                  <source
                    srcset="${current.coverTablet}"
                    media="(max-width: 768px)"
                  />
                  <img
                    src="${current.coverComputer}"
                    alt="${current.coverDescription}"
                    loading="lazy"
                  />
                </picture>
              </div>
              <h2
                class="container-recent-blog-item-title mt-2 lg:mt-6 line-clamp-3 lg:line-clamp-2"
              >
                ${current.title}
              </h2>
              <div class="container-recent-blog-item-date pt-2 lg:pt-4 mt-auto">
                ${current.publishedDate}
              </div>
            </a>
          </li>`,
      ""
    );
  }

  async function renderList() {
    if (!listWrapEle || !containerEle) return;
    const list = await fetchList();
    if (!list || list.length < 1) {
      // empty blogs remove self
      containerEle?.remove();
      containerEle = null;
      return;
    }

    const htmlTemplate = generateHTMLTemplate(list);

    listWrapEle.innerHTML = htmlTemplate;
  }
}
